/**
 * Shared htmx wiring for the Sprig overview components (jobs, news/cases,
 * documents, faq).
 *
 * This lived as a duplicated `{% js %}` block inside each overview template,
 * which put it in an inline script at the end of the cached page HTML. There
 * it shared a single `<script>` tag with every other registered snippet and
 * only ever existed in the initial document — never in a Sprig re-render.
 * Bundling it keeps it out of the page cache entirely.
 */

const initSprigOverview = () => {
    if (window.htmx === undefined) {
        return
    }

    // #indicator in loading-overlay.twig only becomes visible on .loading,
    // so htmx' default request class (htmx-request) never shows the overlay.
    htmx.config.requestClass = 'loading'

    htmx.on('htmx:afterRequest', function (event) {
        /**
         * htmx fires this on the element that issued the request — the filter
         * select or a pagination button inside the component, not the
         * component root — so walk up to the overview we want to scroll to.
         */
        const component =
            event.target instanceof Element
                ? event.target.closest('.sprig-component')
                : null

        if (!component || !window.lenis) {
            return
        }

        /**
         * A load more button appends to what is already on screen, so jumping
         * back to the top of the component is exactly the wrong move. Those
         * components opt out with data-sprig-keep-scroll on their root.
         */
        if (component.hasAttribute('data-sprig-keep-scroll')) {
            return
        }

        setTimeout(() => {
            window.lenis.scrollTo(component, { offset: -100 })
        }, 250)
    })
}

document.addEventListener('DOMContentLoaded', initSprigOverview)

export { initSprigOverview }
